export default "__VITE_ASSET__CZ$ki30g__"